import { render, staticRenderFns } from "./AttendanceTabSwitcher.vue?vue&type=template&id=50e08fa9&scoped=true"
import script from "./AttendanceTabSwitcher.vue?vue&type=script&lang=js"
export * from "./AttendanceTabSwitcher.vue?vue&type=script&lang=js"
import style0 from "./AttendanceTabSwitcher.vue?vue&type=style&index=0&id=50e08fa9&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e08fa9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50e08fa9')) {
      api.createRecord('50e08fa9', component.options)
    } else {
      api.reload('50e08fa9', component.options)
    }
    module.hot.accept("./AttendanceTabSwitcher.vue?vue&type=template&id=50e08fa9&scoped=true", function () {
      api.rerender('50e08fa9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/attendance_v3/components/AttendanceTabSwitcher.vue"
export default component.exports